module.exports = __webpack_public_path__ + "static/media/forgotpassword.a36bc3f5.svg";